module.exports = __webpack_public_path__ + "static/event_img2M@2x-b39f4da52e164f842a672829e92a2d13.png";